import moment from 'moment'
import { DATE_DAY_FORMATE, DATE_MONTH_FORMATE } from './../../../libs/constants'
export const formattingNumber = function(number, digit = 0, unit = 1) {
    const regex = /\B(?=(\d{3})+\b)/g;
    number = Number(number) / unit
    return number.toFixed(digit).replace(regex, ',')
}

// 统计各个项目组
export const makeData = function(sourceData, level = 0, arr) {
    const target = {}
    const keys = Object.keys(sourceData)
    let new_arr = []
    for (let i = 0, len = keys.length; i < len; i++) { // 
        if (level === 0) { 
            /* 
                第一层的数据直接进入第二层
                new_arr表示上一次的项目组的列表
            */
            target[keys[i]] = makeData(sourceData[keys[i]], level + 1, new_arr)
            const current_arr = target[keys[i]]
            current_arr.forEach(item => {
                if (!new_arr.includes(item)) {
                    new_arr.push(item)   
                }
            })
            continue
        }
        new_arr.push(keys[i])
    }
    if (level !== 0 && arr.length === 0) { // 第二层数据且是第一个类别 直接返回所有项目组
        return new_arr
    }
    if (level !== 0 && arr.length !== 0) { 
        // 第二层数据且不是第一个类别 与之前的项目组列表一样，
        // 维持相对顺序并相对于之前的项目组列表做增删改查
        const current = new_arr
        new_arr = []
        arr.forEach(item => {
           if (current.includes(item)) {
            new_arr.push(item)
           } 
        })
        current.forEach(item => {
            if (!arr.includes(item)) {
             new_arr.push(item)
            } 
         })
    }
    if (level === 0) return target
    return new_arr
}

// 组装数据
export const assembleData = function(sourceData, levelOneHash, levelTwoHash) {
    const keys = Object.keys(sourceData) // 三大类别
    let arr = []
    const gathering_obj = { // 最后的大总计
        type: '',
        project: '总计',
        gatherRefund:'收款'
    }
    const refund_obj = {// 最后的大总计
        type: '',
        project: '总计',
        gatherRefund:'退款'
    }
    for (let i = 0, len = keys.length; i < len; i++) {
      const orderHash = {} // 每个类别收入总计
      const refundHash = {}// 每个类别退款总计
      const key = keys[i]
      const current_source = sourceData[key]
      const type = levelOneHash[key] // 获取项目组
      const start = arr.length // 记录开始的index
      levelTwoHash[key].forEach(item => { // 遍历项目组
         const projectData = current_source[item]
         if (!projectData.order) { // 当项目组中没有收款时，占位
            arr.push({
                type,
                project:item,
                gatherRefund:'收款'
            })
         }
         if (projectData.order) { // 对收款数据进行整理 
            let date_total = 0
            const obj = projectData.order.reduce((total, item) => { // 该条目中日期作为key
                total[moment(item[0]).format('MM-DD')] = item[1]
                date_total = math.eval(`${date_total} + ${item[1]}`).toFixed(2); // 该条目的和
               return total
            }, {})
           arr.push({
               type,
               project:item,
               gatherRefund:'收款',
               sum: date_total,
               ...obj
           })
        }
         if (!projectData.refund) { // 当项目组中没有退款时，占位
            arr.push({
                type,
                project:item,
                gatherRefund:'退款'
            })
         }
         if (projectData.refund) {
            let date_total = 0
            const obj = projectData.refund.reduce((total, item) => {
                total[moment(item[0]).format('MM-DD')] = item[1]
                // dateHash[item[0]] = true
                date_total = math.eval(`${date_total} + ${item[1]}`).toFixed(2);
               return total
            }, {})
           arr.push({
               type,
               project:item,
               gatherRefund:'退款',
               sum: date_total,
               ...obj
           })
        }
      })
        for (let i = start; i < arr.length; i++) { // 每一个类别
            const obj = arr[i]
            Object.keys(obj).forEach(dateKey => {
                if (!['type', 'project', 'gatherRefund'].includes(dateKey)) {
                    if (obj.gatherRefund === '收款') {
                        if (!orderHash[dateKey]) {
                            orderHash[dateKey] = 0
                        }
                        if (!gathering_obj[dateKey]) {
                            gathering_obj[dateKey] = 0
                        }
                        gathering_obj[dateKey] = math.eval(`${Number(obj[dateKey] || 0)} + ${Number(gathering_obj[dateKey] || 0) }`).toFixed(2)
                        orderHash[dateKey] = math.eval(`${Number(obj[dateKey] || 0)} + ${ orderHash[dateKey]}`).toFixed(2)
                    } else {
                        if (!refundHash[dateKey]) {
                            refundHash[dateKey] = 0
                        }
                        if (!refund_obj[dateKey]) {
                            refund_obj[dateKey] = 0
                        }
                        refund_obj[dateKey] = math.eval(`${Number(obj[dateKey] || 0)} + ${refund_obj[dateKey]}`).toFixed(2)
                        refundHash[dateKey] = math.eval(`${Number(obj[dateKey] || 0)} + ${refundHash[dateKey]}`).toFixed(2)
                    }
                }
            })
        }
      arr.push({
          type,
          project:'小结',
          gatherRefund:'收款',
          ...orderHash
      })
      arr.push({
        type,
        project:'小结',
        gatherRefund:'退款',
        ...refundHash
      })
    }
    /* 总计 */
    arr = arr.concat([gathering_obj, refund_obj])
    return arr
}

// 选中月份的天

export const daysNumber = function(selectedMonth) {
    let big = null
    const arr = []
    const today = moment(new Date()).format(DATE_MONTH_FORMATE)
    const selected = moment(selectedMonth).format(DATE_MONTH_FORMATE)
    if (today === selected) {
        big = Number(moment(new Date()).format(DATE_DAY_FORMATE).slice(-2))
        big > 1 && big--
    } else {
        big = moment(selectedMonth).daysInMonth()
    }
    for (let i = 1;i <= big;i++) {
        arr.push(i >= 10 ? `${i}` : `0${i}`)
    }
    return arr
}
